<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>

    <div class="container-fluid">

        <!-- HEADER -->
        <div class="container-fluid my-3">
            <div class="top-card" style="display: flex;">
                <div class="row w-100 mx-auto d-flex">
                    <div class="col-8 ps-4">
                        <span>PTE Events</span>
                    </div>
                    <!-- button at center of header vertically only -->
                    <div class="col-4 d-flex justify-content-end align-items-center pe-4">
                        <button class="btn btn-outline-light btn-sm fw-bold" style="border-radius:5px;"
                            (click)="openLastRefreshDialog(); getLmsDsTime()">
                            <b>Last Refresh</b>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <p-dialog header="Last Refresh Details" [(visible)]="isDsTimeDialogVisible" [modal]="true"
            [style]="{width: '500px'}" [closable]="true" (onHide)="closeLastRefreshDialog()">

            <p-table [value]="dsTimeTableRows">

                <ng-template pTemplate="header">
                    <tr>
                        <th>Section</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Message</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>{{ row.section }}</td>
                        <td>{{ row.start_time }}</td>
                        <td>{{ row.end_time }}</td>
                        <td>{{ row.message }}</td>
                    </tr>
                </ng-template>

            </p-table>

        </p-dialog>

        <!-- FILTER CARD -->
        <!-- FILTER CARD -->
        <div class="card filter-card mb-3">
            <div class="card-body py-3">
                <div class="row g-3 align-items-end">

                    <!-- SEARCH: wider on History, narrower on Recent -->
                    <div [ngClass]="dropdownType === 'today' ? 'col-12 col-md-2' : 'col-12 col-md-3'">
                        <label class="filter-label">Search</label>
                        <input type="text" class="form-control filter-control"
                            placeholder="Search by NDA, Brand, Route, Patent..." [(ngModel)]="searchText" />
                    </div>

                    <!-- TYPE -->
                    <div class="col-12 col-md-2">
                        <label class="filter-label">Type</label>
                        <select class="form-control filter-control" [(ngModel)]="dropdownType"
                            (change)="onDropdownChange()">
                            <option value="today">Recent</option>
                            <option value="history">History</option>
                        </select>
                    </div>

                    <!-- START DATE -->
                    <div class="col-12 col-md-2">
                        <label class="filter-label">Event Start Date</label>
                        <input type="date" class="form-control filter-control" [(ngModel)]="startDate" />
                    </div>

                    <!-- END DATE -->
                    <div class="col-12 col-md-2">
                        <label class="filter-label">Event End Date</label>
                        <input type="date" class="form-control filter-control" [(ngModel)]="endDate" />
                    </div>

                    <!-- INSERTED START DATE (Recent only) -->
                    <div class="col-12 col-md-2" *ngIf="dropdownType === 'today'">
                        <label class="filter-label">Inserted Start Date</label>
                        <input type="date" class="form-control filter-control" [(ngModel)]="insertedStartDate" />
                    </div>

                    <!-- INSERTED END DATE (Recent only) -->
                    <div class="col-12 col-md-2" *ngIf="dropdownType === 'today'">
                        <label class="filter-label">Inserted End Date</label>
                        <input type="date" class="form-control filter-control" [(ngModel)]="insertedEndDate" />
                    </div>

                    <!-- BUTTONS INLINE — History only (3 cols remaining after 3+2+2+2=9) -->
                    <div class="col-12 col-md-3 d-flex align-items-end gap-3" *ngIf="dropdownType !== 'today'">
                        <button class="btn btn-primary px-4 mr-2 w-100" (click)="applySearch()">
                            Search
                        </button>
                        <button class="btn btn-outline-secondary px-4 w-100" (click)="resetFilters()">
                            Clear
                        </button>
                    </div>

                </div>

                <!-- BUTTONS ROW — Recent only (all 12 cols used by fields: 2+2+2+2+2+2=12) -->
                <div class="row mt-3" *ngIf="dropdownType === 'today'">
                    <div class="col-12 d-flex justify-content-end gap-3">
                        <button class="btn btn-primary px-4 mr-2" (click)="applySearch()">
                            Search
                        </button>
                        <button class="btn btn-outline-secondary px-4" (click)="resetFilters()">
                            Clear
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <!-- TABLE CARD -->
        <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h5 class="mb-0">PTE Events ({{ totalRecords }})</h5>

                <div class="d-flex align-items-center gap-2">
                    <label class="mb-0 me-2" style="font-size: 13px;">Rows per page: </label>
                    <select class="ml-2 mr-2 form-select form-select-sm" style="width: auto;" [(ngModel)]="pageSize"
                        (ngModelChange)="onPageSizeChange()">
                        <option *ngFor="let opt of pageSizeOptions" [value]="opt"> {{ opt }} </option>
                    </select>
                    <button class="btn btn-sm btn-outline-success" (click)="loadEvents()" [disabled]="isLoading">
                        <i class="fa fa-refresh" [class.fa-spin]="isLoading"></i> Refresh
                    </button>
                </div>
            </div>

            <div class="card-body">

                <!-- LOADING -->
                <div *ngIf="isLoading" class="text-center py-5">
                    <i class="fa fa-spinner fa-spin fa-3x"></i>
                    <p class="mt-3">Loading PTE events...</p>
                </div>

                <!-- NO DATA -->
                <div *ngIf="!isLoading && filteredEvents.length === 0" class="text-center py-5 text-muted">
                    No PTE events found
                </div>

                <!-- TABLE -->
                <div *ngIf="!isLoading && filteredEvents.length > 0" class="table-responsive">
                    <table class="table table-hover">
                        <thead class="table-light">
                            <tr>
                                <th>NDA</th>
                                <th>Brand</th>
                                <th>Route</th>
                                <th>Dosage</th>
                                <th>Patent Number</th>
                                <th>Patent Expiry</th>
                                <th>Patent Type</th>
                                <th>Date of Event</th>
                                <th>Description</th>
                                <th *ngIf="dropdownType=='today'">Inserted At</th>
                                <th>PDF</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let event of filteredEvents">
                                <td>{{ event.nda_number }}</td>
                                <td>{{ event.brand_name }}</td>
                                <td>{{ event.route }}</td>
                                <td>{{ event.dosage }}</td>
                                <td>{{ event.patent_number }}</td>
                                <td>{{ event.patent_expiration }}</td>
                                <td>{{ event.patent_type }}</td>
                                <td>{{ event.official_date }}</td>
                                <td class="desc-cell">
                                    <span>
                                        {{ event.document_description | slice:0:80 }}
                                        <span *ngIf="event.document_description?.length > 80">...</span>
                                    </span>

                                    <a *ngIf="event.document_description?.length > 80" href="javascript:void(0)"
                                        class="read-more" (click)="openDescription(event.document_description)">
                                        Read more
                                    </a>
                                </td>
                                <td *ngIf="dropdownType=='today'">{{ event.inserted_at }}</td>
                                <td>
                                    <button class="btn btn-sm btn-danger" (click)="openPtePdf(event.pdf_url)">
                                        <i class="fa fa-file-pdf-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- PAGINATION -->
                <div *ngIf="!isLoading && totalRecords > 0"
                    class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 pt-3 border-top">
                    <span class="text-muted" style="font-size: 14px;">
                        Showing {{ fromRecord }} to {{ toRecord }} of {{ totalRecords }} entries
                    </span>
                    <nav>
                        <ul class="pagination pagination-sm mb-0">
                            <!-- First -->
                            <li class="page-item" [class.disabled]="page === 1">
                                <a class="page-link" href="#" (click)="goToPage(1); $event.preventDefault()">
                                    << </a>
                            </li>
                            <!-- Previous -->
                            <li class="page-item" [class.disabled]="page === 1">
                                <a class="page-link" href="#" (click)="goToPage(page - 1); $event.preventDefault()">
                                    < </a>
                            </li>
                            <!-- Pages -->
                            <li class="page-item" *ngFor="let p of pageNumbers" [class.active]="page === p">
                                <a class="page-link" href="#" (click)="goToPage(p); $event.preventDefault()">
                                    {{ p }}
                                </a>
                            </li>
                            <!-- Next -->
                            <li class="page-item" [class.disabled]="page === totalPages">
                                <a class="page-link" href="#" (click)="goToPage(page + 1); $event.preventDefault()">
                                    >
                                </a>
                            </li>
                            <!-- Last -->
                            <li class="page-item" [class.disabled]="page === totalPages">
                                <a class="page-link" href="#" (click)="goToPage(totalPages); $event.preventDefault()">
                                    >>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>

            </div>
        </div>

    </div>
</div>